import LoginSvg from '../../../assets/img/icons/login.svg'
import LogoSvg from '../../../assets/img/icons/logo.svg'
import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import useTogglePopup from '../../Modal/useTogglePopup'
import { AlreadyWorkingModal } from './AlreadyWorkingModal'
import { Avatars, Icons } from '../../../../youtalk-storybook/src/ui'
import { Button } from '../../../atoms/Button'
import { gifteryCertificatePurchase } from '../../GA'
import { size as sizePlatform } from '../../../constants'
import { useSaveReferalParameter } from '../../../atoms/useSaveReferalParameter'
export { Link as MenuLink } from 'gatsby'

export { useOpenSocial as GAuseOpenSocial } from '../../GA'

export const size = {
  sm: sizePlatform.sm,
  md: sizePlatform.md,
  xs: sizePlatform.xs,
  xs375: sizePlatform.xs375
}

export const isBrowser = typeof window !== 'undefined'

export const useHeaderInit = () => {
  useSaveReferalParameter('pt_promocode')

  useEffect(() => {
    const listener = (e: MessageEvent<any>) => {
      if (e?.origin !== 'https://widget.giftery.cards') {
        return
      }

      if (e?.data?.event === 'purchaseCertificateYouTalk') {
        gifteryCertificatePurchase(e?.data?.sum)
      }
    }
    if (isBrowser) {
      window.addEventListener('message', listener)
    }

    return () => {
      if (isBrowser) {
        window.removeEventListener('message', listener)
      }
    }
  }, [])
}

export const useMenuVisible = () => {
  const refRoot = useRef<Element | null>(null)
  const [sticky, setSticky] = useState(false)
  const [st, setSt] = useState(0)
  const [prevSt, setPrevSt] = useState(0)

  useEffect(() => {
    refRoot.current = document.querySelector('.root')
  }, [])

  useEffect(() => {
    let timeout: any = null
    const handleScroll = () => {
      if (!refRoot.current) return

      timeout = setTimeout(() => {
        if (!refRoot.current) return
        setSt(refRoot.current.scrollTop)
        setSticky(prevSt < st && refRoot.current.scrollTop > 100)
        setPrevSt(st)
      }, 100)
    }

    if (refRoot.current) {
      refRoot.current.addEventListener('scroll', handleScroll)
    }

    return () => {
      if (refRoot.current) {
        refRoot.current.removeEventListener('scroll', handleScroll)
        clearTimeout(timeout)
      }
    }
  }, [prevSt, st, refRoot])

  return !sticky
}

const ButtonLoginIcon = styled(Button.NewOutline)`
  width: 48px;
  height: 48px;
`

const PickSpecialistButton = styled(Button.Grey)`
  background: #e3f5f5;
  color: #03b2a5;
  border-color: #e3f5f5;
  &:hover {
    background: #aee1dd;
    border-color: #aee1dd;
  }
  height: 48px !important;
  @media (max-width: ${size.xs375}) {
    display: none;
  }
`

const LoginIcon = () => (
  <img alt="Войти" height={24} src={LoginSvg} width={24} />
)

const LogoImage = () => (
  <img alt="YouTalk" height={36} src={LogoSvg} width={51} />
)

const FacebookIcon = () => (
  <img
    alt="Иконка логотипа fb"
    height={32}
    src="/img/icons/header-soc/fb.svg"
    width={32}
  />
)

const InstagramIcon = () => (
  <img
    alt="Иконка логотипа instagram"
    height={32}
    src="/img/icons/header-soc/inst.svg"
    width={32}
  />
)

const VkIcon = () => (
  <img
    alt="Иконка логотипа ВКонтакте"
    height={32}
    src="/img/icons/header-soc/vk.svg"
    width={32}
  />
)

const TelegramIcon = () => (
  <img
    alt="Иконка логотипа telegram"
    height={32}
    src="/img/icons/header-soc/tg.svg"
    width={32}
  />
)

const LinkWithIcon = styled.div`
  margin-right: 8px;
`

export const icons = {
  UserIcon: (
    <LinkWithIcon>
      <Avatars.AvatarClosed2 />
    </LinkWithIcon>
  ),
  Account: (
    <LinkWithIcon>
      <Icons.IconEnter />
    </LinkWithIcon>
  ),
  Exit: (
    <LinkWithIcon>
      <Icons.IconPerson />
    </LinkWithIcon>
  ),
  LogoImage,
  FacebookIcon,
  InstagramIcon,
  VkIcon,
  TelegramIcon
}

type MenuButtonsProps = {
  hideFindPsychologistButton?: boolean
  className?: string
}

export const MenuButtons = styled((props: MenuButtonsProps) => {
  const { isShowing, tglPopup } = useTogglePopup()

  return (
    <div className={props.className}>
      {!props.hideFindPsychologistButton && (
        <PickSpecialistButton href="/wizard/" type="link">
          Найти&nbsp;психолога
        </PickSpecialistButton>
      )}
      <ButtonLoginIcon onClick={tglPopup}>
        <LoginIcon />
      </ButtonLoginIcon>
      {isShowing && <AlreadyWorkingModal hide={tglPopup} />}
    </div>
  )
})`
  display: flex;
  gap: 8px;
  width: 100%;
  justify-content: end;
`

export const MenuGrid = (props: any) => (
  <div className="container">{props.children}</div>
)
